// extracted by mini-css-extract-plugin
module.exports = {"rentRoomContainer":"RentRoomList_rentRoomContainer__Rf4sY","wrapText":"RentRoomList_wrapText__3g997"};